export default __webpack_public_path__ + "tube-dark.svg";